// extracted by mini-css-extract-plugin
export default {"proceduralcoding__title":"proceduralcoding_proceduralcoding__title__q+rOj","proceduralcoding__button-container":"proceduralcoding_proceduralcoding__button-container__HevOL"};